import React from 'react';
import { css } from '@emotion/react';
import Typography from '../../primitives/typography';
import ColSet from '../../primitives/grid/col-set';
import StyledPhoneNumber from './styled-phone-number';
import { DropdownMenuProps } from './styled-dropdown';
import formatPhoneLink from '../../utils/format-phone-link';

const styles = {
    colSet: css({
        display: 'flex',
        position: 'relative',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: 'auto',
        width: 'auto',
    }),
    typography: css({
        textAlign: 'right',
        whiteSpace: 'nowrap',
        span: {
            lineHeight: 1.1,
        },
    }),
};

const StyledPhoneBlock = ({
    text,
    phoneNumber,
    phoneDisplay,
}: DropdownMenuProps): JSX.Element => (
    <ColSet
        breakpoints={{
            dt: { between: 10 },
        }}
        css={styles.colSet}
    >
        <Typography
            fontSize="sm"
            css={styles.typography}
        >
            <span>{text}</span>
            {phoneNumber && (
                <StyledPhoneNumber
                    href={`tel:${phoneNumber}`}
                >
                    {formatPhoneLink(phoneNumber || phoneDisplay)}
                </StyledPhoneNumber>
            )}
        </Typography>
    </ColSet>
);

export default StyledPhoneBlock;
